import { Autocomplete, Chip, TextField } from "@mui/material";
import { Controller } from "react-hook-form";

export default function FormChipInput({
  name,
  control,
  label,
  rules,
  ...rest
}) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={[]}
      render={({ field: { value, onChange }, fieldState }) => (
        <Autocomplete
          multiple
          freeSolo
          options={[]}
          value={value || []}
          onChange={(_, newValue) => onChange(newValue)}
          renderTags={(chips, getTagProps) =>
            chips.map((option, index) => (
              <Chip
                variant="outlined"
                label={option}
                {...getTagProps({ index })}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              {...rest}
              variant="outlined"
              label={label || name}
              placeholder="Type and press Enter"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
      )}
    />
  );
}
